import { render, staticRenderFns } from "./SalaryLogin.vue?vue&type=template&id=ce8687c0&"
import script from "./SalaryLogin.vue?vue&type=script&lang=js&"
export * from "./SalaryLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports